import axios from "axios";

export default {
  sendEmail(data) {
    return axios.post("/api/email", data);
  }
};
